export var PluginType;
(function (PluginType) {
    PluginType["CAROUSEL"] = "CAROUSEL";
    PluginType["LIST"] = "LIST";
    PluginType["PLAYLIST"] = "PLAYLIST";
    PluginType["GALLERY"] = "GALLERY";
    PluginType["PIP"] = "PIP";
})(PluginType || (PluginType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["OLDEST"] = "OLDEST";
    SortOrder["NEWEST"] = "NEWEST";
    SortOrder["RANDOM"] = "RANDOM";
})(SortOrder || (SortOrder = {}));
